export default __webpack_public_path__ + "static/media/green-instagram.49bdba63.png";